var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c(
            "el-row",
            { staticClass: "latest-tasks-wrapper" },
            [
              _c("task-table-view", {
                attrs: { title: _vm.$t("Latest Tasks") }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c(
            "el-row",
            { staticClass: "node-info-view-wrapper" },
            [_c("node-info-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }